import { merge } from 'lodash-es'
import VueI18n from 'vue-i18n'
import enUS from '../../en-US.json'
// Bridge: the keys only the legacy policy views render. Goes with src/legacy —
// see src/legacy/policies/README.md. Merged under en-US, never over it.
import legacyPolicyEnUS from '../../legacy-policy.en-US.json'

let i18n: VueI18n

export function getVueI18n(): VueI18n {
  if (i18n) return i18n

  i18n = new VueI18n({
    messages: {
      'en-US': merge({}, legacyPolicyEnUS, enUS),
    },
    silentTranslationWarn: true, // Use silentFallbackWarn in next i18n version
  })
  return i18n
}
